<template>
		<nav
			class="c-axiell-search__pagination c-pagination c-pagination--axiell o-grid__item"
		>
			<ol class="c-pagination__list">
				
				<li class="c-pagination__item c-pagination__prev">
					<a
						class="c-pagination__link"
						href="#"
						:class="{ 'is-disabled': currentPage <= 1 }"
						@click.prevent="prevPage()"
					>
						<
					</a>
				</li>

				<li class="c-pagination__item c-pagination__first" v-if="currentPage > 3">
					<a
						class="c-pagination__link"
						href="#"
						@click.prevent="firstPage()"
					>
						1
					</a>
				</li>

				<li class="c-pagination__item c-pagination__ellipse" v-if="currentPage > 3">
					...
				</li> 

				<li class="c-pagination__item" v-if="currentPage > 2">
					<a
						class="c-pagination__link"
						href="#"
						@click.prevent="setPage(parseInt(currentPage) - 2)"
					>
					{{ parseInt(currentPage) - 2 }}
					</a>
				</li>

				<li class="c-pagination__item" v-if="currentPage > 1">
					<a
						class="c-pagination__link"
						href="#"
						@click.prevent="setPage(parseInt(currentPage) - 1)"
					>
					{{ parseInt(currentPage) - 1 }}
					</a>
				</li>

				<li class="c-pagination__item c-pagination__current">
					<a 
						href="#" 
						class="c-pagination__link is-active"
						@click.prevent="setPage(parseInt(currentPage))"
					>
						{{ parseInt(currentPage) }}
					</a>
				</li>

				<li class="c-pagination__item" v-if="currentPage < lastPageNumber ">
					<a
						class="c-pagination__link"
						href="#"
						@click.prevent="setPage(parseInt(currentPage) + 1)"
					>
						{{ parseInt(currentPage) + 1 }}
					</a>
				</li>

				<li class="c-pagination__item" v-if="currentPage < (lastPageNumber - 1)">
					<a
						class="c-pagination__link"
						href="#"
						@click.prevent="setPage(parseInt(currentPage) + 2)"
					>
						{{ parseInt(currentPage) + 2 }}
					</a>
				</li>

				<li class="c-pagination__item c-pagination__ellipse" v-if="currentPage < (lastPageNumber - 2)">
					...
				</li> 

				<li class="c-pagination__item c-pagination__last" v-if="currentPage < (lastPageNumber - 2)">
					<a 
						href="#"	
						class="c-pagination__link"
 						:class="{ 'is-disabled': currentPage >= lastPageNumber }"  
						@click.prevent="lastPage()"
					>
						{{ parseInt(lastPageNumber) }}
					</a>
				</li> 
				
				<li class="c-pagination__item c-pagination__next">
					<a 
						href="#"
						class="c-pagination__link"
 						:class="{ 'is-disabled': currentPage >= lastPageNumber }"
						@click.prevent="nextPage()"
					>
						>
					</a>
				</li>

			</ol>
		</nav>

</template>

<script>
	export default {
		data() {
			return {
				loading: false,
			};
		},
		props: ['currentPage', 'lastPageNumber'],
		methods: {
			nextPage() {
				const self = this;

				let i = parseInt(self.currentPage) + 1

				self.$emit('setPage', i)
			},
			prevPage() {
				const self = this;

				let i = parseInt(self.currentPage) - 1

				self.$emit('setPage', i)
			},
			setPage(i) {
				const self = this;

				self.$emit('setPage', i)
			},
			firstPage() {
				const self = this;

				let i = 1;

				self.$emit('setPage', i)
			},
			lastPage() {
				const self = this;

				let i = parseInt(self.lastPageNumber);

				self.$emit('setPage', i)
			},
		},
	};
</script>
